<template>
  <Dialog
    :visible="modelValue"
    @update:visible="emit('update:modelValue', $event)"
    :modal="true"
    :closable="false"
    class="claim-education-dialog"
  >
    <div class="education-content">
      <h3 class="text-lg font-semibold mb-4">Important Information About Claims</h3>
      
      <div class="mb-4">
        <p class="font-bold mb-2">Are you familiar with Private Adjusters (PA)?</p>
        <p class="mb-4">
          A PA is a private adjuster that you are hiring for a fee, which is often
          times a percentage of the total settlement. Unfortunately, it's become
          common practice for PA's to inflate the claim amount in order to
          increase their fee, which can cause significant delays in the processing
          and closing of the claim. Your insurance company however will promptly
          assign an Adjuster to your claim, at no cost to you.
        </p>
      </div>
      
      <div class="mb-4">
        <p class="font-bold mb-2">What about an Assignment of Benefits (AOB)?</p>
        <p>
          An AOB is a contract that once signed, transfers full control of the
          claim from you the customer. To the contractor - allowing the contractor
          to collect payment directly from your insurance company. This gives the
          contractor the latitude to perform work before the insurance company has
          an opportunity to appraise the damage which could lead to disagreements
          about the settlement amount. If the insurance company determines that
          the claim settlement amount is less than the amount of the contractor's
          bill, you as the customer could be on the hook to pay the difference out
          of pocket, ultimately forcing the decision whether to do a contractor
          lien.
        </p>
        <p class="mt-2">
          Unfortunately, there are contractors out there that will also exaggerate
          the amount of the damage for a bigger pay day. And this could leave you
          in a very compromised position.
        </p>
      </div>
      
      <div class="mt-6">
        <form @submit.prevent="handleAcknowledgement">
          <div class="flex items-start mb-4">
            <input
              type="checkbox"
              id="acknowledgement"
              v-model="acknowledgementChecked"
              :class="[props.customerType === 'customer' ? 'enhanced-checkbox-customer' : 'enhanced-checkbox', 'mt-1 mr-2']"
            />
            <label for="acknowledgement" class="text-sm">
              By checking this box you acknowledge you have read the above
              statements.
            </label>
          </div>
          
          <button
            type="submit"
            :disabled="!acknowledgementChecked"
            :class="[
              customerType === 'lender' ? 'btn-lender' : 'btn-customer',
              !acknowledgementChecked ? 'opacity-50 cursor-not-allowed' : '',
              'w-full py-2 px-4 rounded'
            ]"
          >
            Close
          </button>
        </form>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Dialog } from '@/components/ui';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  customerType: {
    type: String,
    default: 'customer',
    validator: (value) => ['lender', 'customer'].includes(value)
  }
});

const emit = defineEmits(['update:modelValue']);

const acknowledgementChecked = ref(false);

// Reset checkbox when dialog opens
watch(() => props.modelValue, (newValue) => {
  if (newValue) {
    acknowledgementChecked.value = false;
  }
});

const handleAcknowledgement = () => {
  if (acknowledgementChecked.value) {
    emit('update:modelValue', false);
  }
};
</script>

<style scoped>
.claim-education-dialog {
  max-width: 600px;
  margin: 0 auto;
}

.education-content {
  padding: 1rem;
}

/* Inherit button styles from global stylesheet */
</style> 